import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';

export const FooterCopyright: FC = () => {
  return (
    <div className="footer__copyright hide_on--mobile">
      <Hyperlink
        href="/e/forseti/820867877/ENT8D14971E01180556690E?source=footer_static"
        className="footer__copyright__forseti_link"
      >
        <FormattedMessage id="footer/components/copyright/FooterCopyright.tsx/1" />
      </Hyperlink>{' '}
      <FormattedMessage id="footer/components/copyright/FooterCopyright.tsx/2" />
    </div>
  );
};
